<script>
import Card from './Card'

export default {
  functional: true,
  props: {
    cardholderName: {
      type: String,
      required: true,
    },
    accountNumber: {
      type: String,
      required: true,
    },
  },
  render(createElement, context) {
    const componentClass = 'ddc-container'
    const data = {
      ...context.data,
      staticClass: [context.data.staticClass, componentClass].join(' ').trim(),
      props: {
        cardType: context.parent.$t('payment_methods.direct_deposit'),
        cardholderName: context.props.cardholderName,
        accountNumber: context.props.accountNumber,
      },
      scopedSlots: {
        'bank-logo': () =>
          createElement('img', {
            class: 'ddc-uptogether-logo',
            attrs: {
              src: require('./assets/uptogether.png'),
              alt: '',
            },
          }),
        'card-logo': () =>
          createElement('img', {
            class: 'ddc-us-bank-logo',
            attrs: {
              src: require('./assets/us-bank.png'),
              alt: '',
            },
          }),
      },
    }
    return createElement(Card, data, context.children)
  },
}
</script>

<style lang="postcss" scoped>
.ddc-container {
  /* Base */
  background: linear-gradient(0.43deg, #d70073 0.35%, #f15b41 99.61%);
}

.ddc-uptogether-logo {
  /* Base */
  @apply tw-w-[65.7px] tw-h-[31.4px] tw-object-contain;
}

.ddc-us-bank-logo {
  /* Base */
  @apply tw-w-[63.5px] tw-h-[16.5px] tw-object-contain;

  /* Desktop */
  @apply lg:tw-w-[99px] lg:tw-h-[25px];
}
</style>
